import { render, staticRenderFns } from "./EsgTableWithoutMeta.vue?vue&type=template&id=12d88d02"
import script from "./EsgTableWithoutMeta.vue?vue&type=script&lang=js"
export * from "./EsgTableWithoutMeta.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports